export default __webpack_public_path__ + "static/solid-314467bd8548ff77f22ff0a38f33b6d7.png";